import { render, staticRenderFns } from "./m-form-pos-terminal-settings.vue?vue&type=template&id=5c29ce1c&scoped=true&lang=pug&"
import script from "./m-form-pos-terminal-settings.vue?vue&type=script&lang=js&"
export * from "./m-form-pos-terminal-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c29ce1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
